<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open -extra-width' : modalStatus,
                  '-is-closed': !modalStatus}">

  <div class="esf-main-sidebar__content">
    <h3>{{ i18nHeading }}</h3>
    <form [formGroup]="assignedReductionsForm" (ngSubmit)="formSubmit()" id="assignedReductionsForm">
      <table class="esf-table">
        <thead class="esf-table__head">
          <tr class="esf-table__row">
            <th class="esf-table__cell esf-table__cell--head"
                i18n-data-label='Table cell heading@@general.tableCellLabel.name'
                data-label="Name">
              <span class="esf-table__cell-inner"
                    i18n='Table cell heading@@general.tableCellLabel.name'>Name</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head"
                i18n-data-label='Table cell heading@@general.tableCellLabel.active'
                data-label="Active">
              <span class="esf-table__cell-inner"
                    i18n='Table cell heading@@general.tableCellLabel.active'>Active</span>
            </th>
          </tr>
        </thead>
        <tbody class="esf-table__body">
          <ng-container *ngFor="let priceReduction of priceReductionList">
            <tr class="esf-table__row">
              <td class="esf-table__cell"
                  data-label="Name">
                <span class="esf-table__cell-inner">
                  {{ priceReduction.name }}
                </span>
              </td>

              <td class="esf-table__cell"
                  data-label="Status">
                <div class="esf-toggle">
                  <input class="esf-toggle__input"
                         type="checkbox"
                         [id]="priceReduction.id"
                         [checked]="priceReduction.checked"
                         (change)="priceReduction.checked = !priceReduction.checked">
                  <label class="esf-toggle__label"
                         [for]="priceReduction.id">
                    <div class="esf-toggle__button">
                      <div class="esf-toggle__button-background">
                        <div class="esf-toggle__button-handle"></div>
                      </div>
                    </div>
                  </label>
                </div>
              </td>
            </tr>

            <div app-form-field-number
                 *ngIf="priceReduction.checked"
                 style="margin-top: calc((1rem + 1vw)/1.5);"
                 [(inputValue)]="priceReduction.reducedAmount"
                 [placeholder]="flTranslations.i18nAmount"
                 [label]="flTranslations.i18nAmount">
            </div>

          </ng-container>
        </tbody>
      </table>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition"
     [ngClass]="{'-is-open -extra-width': modalStatus}">
  <app-submit-row-buttons [form]="'assignedReductionsForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          [isFieldValid]="selectedLottery.isDraftMode"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition"
     (click)="tixxSelectOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': modalStatus}">
  <span class="esf-hamburger__icon"></span>
</div>
